import { useTenant } from "@/providers/session";
import { useMutation } from "@apollo/client";
import { gql } from "@apollo/client";
import { noop } from "lodash";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";

import { GET_ALL_WHATSAPP_FORWARDINGS } from "./get-all";

type CreateWhatsAppForwardingInput = {
  phoneNumber: string;
  name: string;
};

export const useCreateWhatsAppForwarding = () => {
  const { t } = useTranslation();
  const { tenantId } = useTenant();
  const [createWhatsAppForwarding, { data, loading, error }] = useMutation(
    CREATE_WHATSAPP_FORWARDING_MUTATION,
    {
      refetchQueries: [GET_ALL_WHATSAPP_FORWARDINGS],
    },
  );

  const handleCreateWhatsAppForwarding = async (
    input: CreateWhatsAppForwardingInput,
    onSuccess: () => void = noop,
    onError: () => void = noop,
  ) => {
    if (!tenantId) {
      throw new Error("Tenant ID is required");
    }

    return toast.promise(
      createWhatsAppForwarding({
        variables: {
          tenantId,
          ...input,
        },
      }),
      {
        success: () => {
          onSuccess();
          return t("generic_success");
        },
        error: () => {
          onError();
          return t("generic_error", { richColors: true });
        },
      },
    );
  };

  return {
    createWhatsAppForwarding: handleCreateWhatsAppForwarding,
    data: data?.createWhatsAppForwarding,
    loading,
    error,
  };
};

export const CREATE_WHATSAPP_FORWARDING_MUTATION = gql`
  mutation CreateWhatsAppForwarding(
    $tenantId: String!
    $phoneNumber: String!
    $name: String!
  ) {
    createWhatsAppForwarding(
      tenantId: $tenantId
      phoneNumber: $phoneNumber
      name: $name
    ) {
      whatsappForwardingId
      phoneNumber
      name
      onboardingState
      createdAt
      updatedAt
    }
  }
`;
